module.exports = __webpack_public_path__ + "img/Error.ef72edee.svg";